// extracted by mini-css-extract-plugin
module.exports = {"buttonModal":"src-components-ButtonModal-ButtonModal_buttonModal--31lHnUGf"};